var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNogasolineras({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.924,
    height: 77.345,
    viewBox: "0 0 77.924 77.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14534",
    "data-name": "Grupo 14534",
    transform: "translate(-145 -448.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14451",
    "data-name": "Grupo 14451",
    transform: "translate(4 38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13069",
    "data-name": "Grupo 13069",
    transform: "translate(-4398.365 -1001.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13066",
    "data-name": "Grupo 13066",
    transform: "translate(4539.366 1415.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13063",
    "data-name": "Grupo 13063",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13061",
    "data-name": "Grupo 13061",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10125",
    "data-name": "Trazado 10125",
    d: "M37.024,0A37.024,37.024,0,1,1,0,37.024,37.024,37.024,0,0,1,37.024,0Z",
    transform: "translate(0 0)",
    fill: "#fca534"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13068",
    "data-name": "Grupo 13068",
    transform: "translate(4580.729 1422.475) rotate(2)",
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13064",
    "data-name": "Grupo 13064",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10124",
    "data-name": "Trazado 10124",
    d: "M2.128,0,2.3,0l.141.007.265.017c.174.012.342.029.51.046C3.55.11,3.877.154,4.2.2c.648.1,1.286.225,1.916.368A29.1,29.1,0,0,1,9.8,1.693a29.263,29.263,0,0,1,6.713,3.588,28.223,28.223,0,0,1,2.93,2.389c.47.418.9.874,1.344,1.317.218.225.423.462.634.692s.422.46.617.7a34.83,34.83,0,0,1,4.132,6.159.957.957,0,0,1-1.649.968l-.005-.007a32.588,32.588,0,0,0-4.335-5.413c-.2-.209-.41-.4-.62-.6s-.416-.394-.631-.582c-.438-.368-.863-.75-1.321-1.09A25.348,25.348,0,0,0,14.8,7.9,25.843,25.843,0,0,0,8.623,5.242a25.228,25.228,0,0,0-3.258-.7c-.546-.076-1.092-.135-1.633-.172-.27-.017-.539-.03-.8-.034-.131,0-.262,0-.387,0l-.184,0-.083,0a.265.265,0,0,0-.053,0A2.176,2.176,0,1,1,2.128,0Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13060",
    "data-name": "Grupo 13060",
    transform: "translate(-457.006 250.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13058",
    "data-name": "Grupo 13058",
    transform: "translate(618.459 191.887)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_15",
    "data-name": "L\\xEDnea 15",
    x2: 11.692,
    y2: 10.793,
    transform: "translate(0 0.45)",
    fill: "none",
    stroke: "#1d253c",
    strokeMiterlimit: 10,
    strokeWidth: 3.077
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_16",
    "data-name": "L\\xEDnea 16",
    y1: 11.692,
    x2: 10.793,
    transform: "translate(0.45)",
    fill: "none",
    stroke: "#1d253c",
    strokeMiterlimit: 10,
    strokeWidth: 3.077
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13059",
    "data-name": "Grupo 13059",
    transform: "translate(641.843 191.887)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_17",
    "data-name": "L\\xEDnea 17",
    x2: 11.692,
    y2: 10.793,
    transform: "translate(0 0.45)",
    fill: "none",
    stroke: "#1d253c",
    strokeMiterlimit: 10,
    strokeWidth: 3.077
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_18",
    "data-name": "L\\xEDnea 18",
    y1: 11.692,
    x2: 10.793,
    transform: "translate(0.45)",
    fill: "none",
    stroke: "#1d253c",
    strokeMiterlimit: 10,
    strokeWidth: 3.077
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10122",
    "data-name": "Trazado 10122",
    d: "M635.539,201.451a10.527,10.527,0,0,0-1.14-.969,14.233,14.233,0,0,0-16.4.238",
    transform: "translate(9.228 18.003)",
    fill: "none",
    stroke: "#1d253c",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10639",
    "data-name": "Trazado 10639",
    d: "M2350.5-478.464l26.242,26.242",
    transform: "translate(-2161 892)",
    fill: "none",
    stroke: "#ef4b4b",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10640",
    "data-name": "Trazado 10640",
    d: "M2376.742-478.464,2351.8-453.522",
    transform: "translate(-2161 892)",
    fill: "none",
    stroke: "#ef4b4b",
    strokeWidth: 9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNogasolineras);
export default __webpack_public_path__ + "static/media/nogasolineras.071165b7fbc7834ff01e05c8fd243f07.svg";
export { ForwardRef as ReactComponent };